import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IDashboardMidwifePayload, IDashboardMidwifeResponse, IReview } from 'src/app/models/dashboard.models';
import { RatingService } from 'src/app/services/rating.service';

@Component({
  selector: 'app-rating-listing',
  templateUrl: './rating-listing.component.html',
  styleUrls: ['./rating-listing.component.scss']
})
export class RatingListingComponent implements OnInit {

  midwife: IDashboardMidwifePayload;

  reviews: Array<IReview> = [];
  midwifeId: any;
  loading: boolean = true;

  progressTitle: Array<string> = [];
  progressPercent: number;
  ratingProgressBar: any = {}

  constructor(private _Activatedroute : ActivatedRoute,
    private ratingService: RatingService) { }

  ngOnInit(): void {
    this._Activatedroute.paramMap.subscribe(params => { 
      this.midwifeId = params.get('midwifeId');
      this.getMidwifeReviews(); 
    });
  }

  getMidwifeReviews(){
    let body = {
      midwifeId: this.midwifeId,
    }

    this.ratingService.getMidwifeRating(body)
    .subscribe((res: IDashboardMidwifeResponse)=>{
      this.midwife = res.payload;
      this.reviews = this.midwife.reviews;
      console.log("Rating Listing:", this.reviews);
      this.refreshView();
    },err=>{
      console.error("Blog Detail Error:", err);
      this.loading = false;
    });
  }

  progressBarCss(progress: any){
    if(progress > 60)
    {
      return 'bg-success';
    }else if(progress > 20 && progress <=60)
    {
      return 'bg-warning';
    }
    else{
      return 'bg-danger';
    }
  }

  refreshView(){
    this.progressTitle = [];
    this.progressTitle.push(String(this.midwife.rating));
    this.progressPercent = this.midwife.rating * 100 / 5;
    this.ratingProgressBar = {
      rating1: this.midwife.reviewSummary.rating1Count * 100 / this.midwife.reviewSummary.total,
      rating2: this.midwife.reviewSummary.rating2Count * 100 / this.midwife.reviewSummary.total,
      rating3: this.midwife.reviewSummary.rating3Count * 100 / this.midwife.reviewSummary.total,
      rating4: this.midwife.reviewSummary.rating4Count * 100 / this.midwife.reviewSummary.total,
      rating5: this.midwife.reviewSummary.rating5Count * 100 / this.midwife.reviewSummary.total
    }
    this.loading = false;
  }

}
